import React from 'react';
import { useUser } from '@lore/auth';
import LegacyLayout from './LegacyLayout';
import StreamlinedLayout from './StreamlinedLayout';
import useFeatureFlags from "@/hooks/useFeatureFlags";

export default function Layout() {
  const currentUser = useUser();

  const {isFetching: flagFetching, getStreamlinedAccountFlowEnabled} = useFeatureFlags(currentUser);
  const streamlinedAccountFlowEnabled = getStreamlinedAccountFlowEnabled();

  if (flagFetching) {
    return null;
  }

  if (streamlinedAccountFlowEnabled) {
    return <StreamlinedLayout currentUser={currentUser} />;
  }

  return <LegacyLayout currentUser={currentUser} />;
}
